import React, { useState } from "react";
import { Badge, Nav, Tab, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import AvatarImage from "../../ui/Avatar/AvatarImage";
import Adminrequeststab from "../adminRequestsTab/AdminRequestsTab";
import ScoringAlignment from "./qeptabs/ScoringAlignment";
import "./QepPage.css";
import Score from "../../../assets/images/score.svg";
import Risk from "../../../assets/images/risk.svg";
import Meeting from "../../../assets/images/meeting.svg";
import Field from "../../../assets/images/field.png";
import GoalAction from "./qeptabs/GoalAction";
import MeetingTracker from "./qeptabs/MeetingTracker";

import Surveys from "./qeptabs/Surveys";
import AnalysisOutcomes from "./qeptabs/AnalysisOutcomes";
import ActionStrategy from "./qeptabs/ActionStrategy";
import Export from "./qeptabs/Export";
import ApporvalLetter from "./qeptabs/ApporvalLetter";

export const QepPage = () => {
  const [activeTab, setActiveTab] = useState("scoring-alignment");

  return (
    <div className="qep_pages">
      <div className="files_grid">
        <div className="common_card_file cir_card cursor-pointer">
          <div className="common_card_txt mb-0 ">
            <p>Score Summary</p>
            <h2>40 / 65</h2>
          </div>
          <div className="common_card_icon">
            <div className="icon_color_bg red">
              <img src={Score} alt="score" />
            </div>
          </div>
        </div>
        <div className="common_card_file">
          <div className="common_card_txt mb-0">
            <p>Goals At Risk</p>
            <h2>0</h2>
          </div>
          <div className="common_card_icon">
            <div className="icon_color_bg green">
              <img src={Risk} alt="resourceicon" />
            </div>
          </div>
        </div>
        <div className="common_card_file cursor-pointer">
          <div className="common_card_txt mb-0">
            <p>Next QEP Meeting</p>
            <h2>Sep 24, 2024</h2>
          </div>
          <div className="common_card_icon">
            <div className="icon_color_bg blue">
              <img src={Meeting} alt="filesforreviewicon" />
            </div>
          </div>
        </div>
        <div className="common_card_file cursor-pointer">
          <div className="common_card_txt mb-0">
            <p> Incomplete Fields</p>
            <h2>5</h2>
          </div>
          <div className="common_card_icon">
            <div className="icon_color_bg yellow">
              <img src={Field} alt="emergencytrackingicon" />
            </div>
          </div>
        </div>
      </div>
      <div className="common_card">
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey="scoring-alignment"
        >
          <div className="tab_flx flex-wrap">
            <Nav
              variant="pills"
              className="common_tab"
              activeKey={activeTab}
              onSelect={(selectedKey) =>
                setActiveTab(selectedKey || "scoring-alignment")
              }
            >
              <Nav.Item>
                <Nav.Link eventKey="scoring-alignment">
                  Scoring Alignment
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="goals-action">Goals & Action</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="meeting-tracker">Meeting Tracker</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="surveys">Surveys</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="analysis-outcomes">
                  Analysis & Outcomes
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="action-strategy">Action-Strategy</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="export">Export</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="approval-letter">Approval-letter</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <Tab.Content>
            <Tab.Pane eventKey="scoring-alignment">
              <ScoringAlignment />
            </Tab.Pane>
            <Tab.Pane eventKey="goals-action">
              <GoalAction />
            </Tab.Pane>
            <Tab.Pane eventKey="meeting-tracker">
              <MeetingTracker />
            </Tab.Pane>
            <Tab.Pane eventKey="surveys">
              <Surveys />
            </Tab.Pane>
            <Tab.Pane eventKey="analysis-outcomes">
              <AnalysisOutcomes />
            </Tab.Pane>
            <Tab.Pane eventKey="action-strategy">
              <ActionStrategy />
            </Tab.Pane>
            <Tab.Pane eventKey="export">
              <Export />
            </Tab.Pane>
            <Tab.Pane eventKey="approval-letter">
              <ApporvalLetter />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
};
